<template>
  <div>
    <common-dialog
      ref="dialog"
      width="900px"
      :show-save-button="$permission.canEdit()"
      unit="会员收货地址"
      edit-title
      id-key="RecordId"
      :data="data"
      :get-data-func="api.info"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      close-on-saved
      form-label-width="130px"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="注册手机号码" prop="PersonId">
              <el-select
                v-model="data.PersonId"
                placeholder="请选择注册手机号码"
                clearable
              >
                <el-option
                  v-for="item in personList"
                  :key="item.RecordId"
                  :value="item.RecordId"
                  :label="item.ContactPhone"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="isMB ? 24 : 12">
            <el-row>
              <el-col :span="12">
                <el-form-item label="所在区域" prop="AddressPro">
                  <el-select
                    v-model="data.AddressPro"
                    placeholder="请选择"
                    @change="proChange"
                  >
                    <el-option
                      v-for="item in list2"
                      :key="item.DistrictId"
                      :value="item.Name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="AddressCity" label-width="0">
                  <el-select
                    v-model="data.AddressCity"
                    placeholder="请选择"
                    @change="data.AddressArea = ''"
                    :disabled="!data.AddressPro"
                  >
                    <el-option
                      v-for="item in list3"
                      :key="item.DistrictId"
                      :value="item.Name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="AddressArea" label-width="0">
                  <el-select
                    v-model="data.AddressArea"
                    placeholder="请选择"
                    :disabled="!data.AddressCity"
                  >
                    <el-option
                      v-for="item in list4"
                      :key="item.DistrictId"
                      :value="item.Name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="联系人" prop="ContactName">
              <el-input
                v-model="data.ContactName"
                placeholder="请输入联系人"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="联系电话" prop="ContactPhone">
              <el-input
                v-model="data.ContactPhone"
                placeholder="请输入联系电话"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="收货地址" prop="ContactAddress">
              <el-input
                v-model="data.ContactAddress"
                placeholder="请输入收货地址"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="门牌号" prop="DoorNumber">
              <el-input
                v-model="data.DoorNumber"
                placeholder="请输入门牌号"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="邮政编码" prop="PostalCode">
              <el-input
                v-model="data.PostalCode"
                placeholder="请输入邮政编码"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="默认地址" prop="IsDefault">
              <el-radio-group v-model="data.IsDefault">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="isMB ? 24 : 12">
              <el-form-item label="序号" prop="OrderId">
                <el-input-number v-model="data.OrderId" :min="0" />
              </el-form-item>
            </el-col>  -->
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  props: {
    area: {
      //area的赋值在index.vue里面执行
      type: Array,
      default: () => [],
    },
  },
  computed: {
    list2() {
      return this.area.filter((x) => x.Lv == 1);
    },
    list3() {
      if (this.id1)
        return this.area.filter((x) => x.Lv == 2 && x.Pid == this.id1);
      else return [];
    },
    list4() {
      if (this.id2)
        return this.area.filter((x) => x.Lv == 3 && x.Pid == this.id2);
      else return [];
    },
    id1() {
      if (!this.data.AddressPro) return 0;
      else {
        var obj = this.area.find((x) => x.Name == this.data.AddressPro);
        return obj ? obj.DistrictId : 0;
      }
    },
    id2() {
      if (!this.data.AddressCity) return 0;
      else {
        var obj = this.area.find((x) => x.Name == this.data.AddressCity);
        return obj ? obj.DistrictId : 0;
      }
    },
    id3() {
      if (!this.data.AddressArea) return 0;
      else {
        var obj = this.area.find((x) => x.Name == this.data.AddressArea);
        return obj ? obj.DistrictId : 0;
      }
    },
  },
  data() {
    return {
      data: {
        RecordId: 0,
        OrderId: 0,
        PersonId: "",
        AddressPro: "",
        AddressCity: "",
        AddressArea: "",
        DistrictId: 0,
        ContactName: "",
        ContactPhone: "",
        ContactAddress: "",
        DoorNumber: "",
        PostalCode: "",
        IsDefault: 1,
      },

      personList: [],
      api: require("@/api/person/personaddress").default,
      api2: require("@/api/person/personinfo").default,
      isMB: this.$store.state.isMB,
      rules: {
        PersonId: [{ required: true, message: "会员姓名不能为空" }],
        AddressPro: [{ required: true, message: "请选择省份" }],
        AddressCity: [{ required: true, message: "请选择城市" }],
        AddressArea: [{ required: true, message: "请选择行政区" }],
        ContactName: [{ required: true, message: "联系人不能为空" }],
        ContactPhone: [
          { required: true, message: "联系电话不能为空" },
          { validator: this.$commonJs.validateRules.validPhone2 },
        ],
        ContactAddress: [{ required: true, message: "收货地址不能为空" }],
        OrderId: [{ required: true, message: "序号不能为空" }],
      },
    };
  },
  methods: {
    onCreateOpened(data) {
      this.getOption();
      var personId = data.PersonId || 0;
      this.api.getMaxOrderId(personId).then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
    onEditOpened(data) {
      this.getOption();
    },
    getOption() {
      this.loading(true);
      this.api2.list({}).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          // this.personList = res.Data;
          this.personList = res.Data.map((x) => {
            x.PersonName = x.PersonName ? x.PersonName : " ";
            return { ...x };
          });
        }
      });
    },

    proChange() {
      this.data.AddressCity = "";
      this.data.AddressArea = "";
    },
    onBeforeSave() {
      this.data.DistrictId = this.id3;
    },
    onClosed() {
      this.personList = [];
    },
  },
};
</script>
  